let captureStream: MediaStream | undefined;

export const setCaptureStream = (captureStreamProp: MediaStream | undefined) => {
  captureStream = captureStreamProp;
};

export const getCaptureStream = (): MediaStream | undefined => {
  return captureStream;
};
